import { Scene as ThreeScene } from 'three'

import { webgl } from './GL.js'

export default class BaseScene {

    constructor(props = {}) {
        this.props = props
        this.base = null
        this.camera = null
        this.webgl = webgl
    }


    init() {
        this.base = new ThreeScene()
    }


    update() {}


    render() {}


    resize() {}


    pointermove() {}


    addObject3D(object) {
        if (this.base) this.base.add(object)
        return object
    }


    removeObject3D(object) {
        if (this.base) this.base.remove(object)
        return null
    }


    destroy() {
        if (this.base) this.base.clear()
        this.base = null
        this.camera = null
    }

}
